// extracted by mini-css-extract-plugin
module.exports = {"container":"jGXFO","avatar":"_1b7NV","noPadding":"_3ozUV","contentContainer":"Y_QFk","redDot":"_2gDDC","flasher":"_2pm_H","shape":"_3ehNu"};